/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Row} from "react-bootstrap";


import DOCUMENT_ICON from "@Icons/document.png";


type TransportDocumentsSwitcherProps = {
    SHOW_DOCUMENTS_STATUS: boolean;
    SHOW_DOCUMENTS_STATUS_HANDLER(STATUS: boolean): void;
};


export const TransportDocumentsSwitcherComponent: React.FC<TransportDocumentsSwitcherProps> = ({
    SHOW_DOCUMENTS_STATUS, SHOW_DOCUMENTS_STATUS_HANDLER
}): JSX.Element | null => {


    if (!SHOW_DOCUMENTS_STATUS_HANDLER) return null;


    return (
        <Col xs={3} className={"finished-transport-documents-switcher finished-transport-documents-switcher-component"}>
            <Row className={"finished-transport-documents-switcher-content"}>

                <span className={"documents-switcher-button"} onClick={() => SHOW_DOCUMENTS_STATUS_HANDLER(!SHOW_DOCUMENTS_STATUS)}>
                    <img src={DOCUMENT_ICON} alt={``} />
                </span>

            </Row>
        </Col>
    );

};


export default TransportDocumentsSwitcherComponent;
